import { onShowTogglable } from './togglables';

let scrollElements = document.querySelectorAll('body > section section');
let cardWallElements = document.querySelectorAll('cards-wall-runtime reply-card-runtime');
let throttleTimer: boolean;

const throttle = (callback: () => void, time: number) => {
  if (throttleTimer) return;

  throttleTimer = true;
  setTimeout(() => {
    callback();
    throttleTimer = false;
  }, time);
};

const elementInView = (el: Element, dividend = 1) => {
  const elementTop = el.getBoundingClientRect().top;

  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / dividend
  );
};

const displayScrollElement = (element: Element) => {
  element.classList.add('scrolled');
};

const handleScrollAnimation = () => {
  if (!scrollElements.length) {
    scrollElements = document.querySelectorAll('body > section section, cards-wall-runtime reply-card-runtime');
  }
  cardWallElements = document.querySelectorAll('cards-wall-runtime reply-card-runtime');
  for (const el of scrollElements) {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    }
  }
  for (const el of cardWallElements) {
    if (elementInView(el, 1.25)) {
      displayScrollElement(el);
    }
  }
};

/*const updateOnLoadMoreWallItems = () => {
  document.querySelectorAll('cards-wall-runtime').forEach((el) => {
    el.addEventListener ('DOMNodeInserted', () => { 
      throttle(() => {
        cardWallElements = document.querySelectorAll('cards-wall-runtime reply-card-runtime');
        handleScrollAnimation();
      }, 250);
    }, false);
  });
};*/

const updateOnLoadMoreWallItems = () => {
  const observer = new MutationObserver(() =>
      throttle(() => {
        cardWallElements = document.querySelectorAll('cards-wall-runtime reply-card-runtime');
        handleScrollAnimation();
      }, 250));

  for (const el of document.querySelectorAll('cards-wall-runtime')) {
    observer.observe(el, {childList: true});
  }
};


const root: HTMLElement = document.querySelector(':root');
let menu = document.querySelector<HTMLElement>('custom-menu-runtime');
const mediaQuery = window.matchMedia('(min-width: 1024px)');

const mqChangeMenuHandler = () => {
  if (!menu || !document.body.contains(menu)) {
    menu = document.querySelector<HTMLElement>('custom-menu-runtime');
  }

  const firstLevel = <HTMLElement>menu?.querySelector('#menu-first-level');
  const hamburger = <HTMLElement>menu?.querySelector('#mobile-menu-toggle');

  if (menu && mediaQuery.matches) {
    const isCollapsed = menu.classList.contains('collapsed');

    if (window.scrollY > 200 && !isCollapsed) {
      menu.classList.add('collapsed');
      root.style.setProperty('--header-height', '64px');
      
    } else if (window.scrollY < 172 && isCollapsed) {
      menu.classList.remove('collapsed');
      root.style.setProperty('--header-height', '92px');
    }    
    
    if (hamburger.ariaExpanded === 'true') {
      onShowTogglable(hamburger, firstLevel);
    }

  } else if (firstLevel?.querySelector('[data-toggle="dropdown"][aria-expanded="true"]') && hamburger?.ariaExpanded === 'false') {
    onShowTogglable(hamburger, firstLevel);
  }
};

// const timer = 0;
// const count = 0;

let prevWindowHeight: number;

const calcVh = () => {
    if (prevWindowHeight === window.innerHeight) {
      return;
    }
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    prevWindowHeight = window.innerHeight;
};
calcVh();

document.addEventListener('DOMContentLoaded', handleScrollAnimation);
document.addEventListener('DOMContentLoaded', updateOnLoadMoreWallItems);
document.addEventListener('scroll', () => { 
  throttle(() => {
    handleScrollAnimation();
    mqChangeMenuHandler();
    calcVh();
    // chromeGlitchWorkaroundFunction();
  }, 250);
});

mediaQuery.addEventListener('change', mqChangeMenuHandler);
window.addEventListener('resize', () => throttle(calcVh, 250));

window.onfocus = () => {
  document.querySelector('#menu-first-level')?.getBoundingClientRect();
};
addEventListener('orientationchange', () => {
  const firstLevel: HTMLElement = document.querySelector('#menu-first-level');
  if (firstLevel) {
    firstLevel.style.display = 'flex';
    setTimeout(() => {
      firstLevel.style.display = '';
    }, 100);
  }
});
